var VENUE_ROLE_HOME = "Home";
export var sortParticipantsByVenueRole = function (p1, p2) {
    return p1.venueRole === VENUE_ROLE_HOME ? -1 : 1;
};
//# sourceMappingURL=sortParticipantsByVenueRole.js.map